import generatePicker from "antd/lib/date-picker/generatePicker";
import { Dayjs, extend } from "dayjs";
import localeData from "dayjs/plugin/localeData";
import weekday from "dayjs/plugin/weekday";
import dayjsGenerateConfig from "rc-picker/lib/generate/dayjs";
// eslint-disable-next-line import/order
import "antd/lib/date-picker/style/index";

extend(weekday);
extend(localeData);

/**@deprecated
 *
 * It is not actually "deprecated", we still want to use this, just not directly.
 * This is a wrapper around the antd DatePicker component that uses DayJS as the date library
 * We want to use the various Pickers (DatePicker, TimePicker, etc) which have some baked  styles
 */
export const RVDatePickerDayJSFacade = generatePicker<Dayjs>(dayjsGenerateConfig as any);
